<template>
  <div>

    <Preloader v-if="pageLoader.loading" />

    <router-view />
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import Preloader from '@/components/Preloader.vue'

import { pageLoader } from '@/stores/pageLoader'
import { useHead } from '@unhead/vue'
onMounted(() => {
  setTimeout(() => {
    pageLoader.loading = false
  }, 500)
})
useHead({
  title: 'قلم لايف | نظام إدارة ومتابعة الطلاب للمدرسين والمعاهد',

  meta: [
    {
      name: 'description',
      content:
        'قلم لايف نظام متكامل لإدارة ومتابعة الطلاب للمدرسين والمعاهد والمراكز التعليمية، يشمل الحضور والغياب، الاختبارات، الواجبات، الدفعات والتواصل مع أولياء الأمور.'
    },
    {
      name: 'keywords',
      content:
      'نظام إدارة ومتابعة الطلاب، نظام إدارة ومتابعة الطلاب للمعاهد، نظام إدارة الطلاب، نظام متابعة الطلاب، برنامج إدارة المعاهد، برنامج إدارة المراكز التعليمية، نظام للمدرسين، إدارة الحضور والغياب، متابعة الطلاب، إدارة الاختبارات، إدارة الدفعات، التواصل مع أولياء الأمور.'
    }
  ]
})
</script>

<style lang="scss" scoped>
</style>
